import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MdArrowBack, MdHome } from 'react-icons/md';

export default function PageNotFound() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #050510 0%, #0D0D2B 50%, #0A0520 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Inter', -apple-system, sans-serif",
      padding: 24, position: 'relative', overflow: 'hidden',
    }}>
      {/* background orbs */}
      <div style={{ position: 'absolute', width: 600, height: 600, borderRadius: '50%', background: 'radial-gradient(circle, rgba(124,58,237,0.25) 0%, transparent 70%)', top: -150, left: -150, pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle, rgba(59,130,246,0.18) 0%, transparent 70%)', bottom: -100, right: -100, pointerEvents: 'none' }} />
      {/* grid */}
      <div style={{ position: 'absolute', inset: 0, backgroundImage: 'linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)', backgroundSize: '60px 60px', pointerEvents: 'none' }} />

      <div style={{ textAlign: 'center', position: 'relative', zIndex: 1, maxWidth: 500 }}>
        {/* glowing 404 */}
        <div style={{
          fontSize: 'clamp(80px, 20vw, 140px)', fontWeight: 900, lineHeight: 1,
          background: 'linear-gradient(135deg, #7C3AED, #4F46E5)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          filter: 'drop-shadow(0 0 40px rgba(124,58,237,0.5))',
          marginBottom: 8,
        }}>404</div>

        <div style={{
          background: 'rgba(255,255,255,0.07)',
          backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)',
          border: '1px solid rgba(255,255,255,0.10)', borderRadius: 20,
          padding: '32px 40px', marginBottom: 32,
        }}>
          <h1 style={{ color: '#fff', fontSize: 24, fontWeight: 700, margin: '0 0 12px', letterSpacing: '-0.5px' }}>
            Page not available
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 15, lineHeight: 1.6, margin: 0 }}>
            The page you're looking for doesn't exist or the URL might be incorrect.
            Double-check the address and try again.
          </p>
        </div>

        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              height: 44, padding: '0 22px', borderRadius: 12,
              background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.13)',
              color: '#fff', fontWeight: 500, fontSize: 14,
              cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8,
              transition: 'all 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.13)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.07)'}
          >
            <MdArrowBack size={18} /> Go Back
          </button>
          <button
            onClick={() => navigate('/')}
            style={{
              height: 44, padding: '0 22px', borderRadius: 12,
              background: 'linear-gradient(135deg, #7C3AED, #4F46E5)',
              border: 'none', color: '#fff', fontWeight: 600, fontSize: 14,
              cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8,
              transition: 'opacity 0.2s, transform 0.2s',
            }}
            onMouseEnter={e => { e.currentTarget.style.opacity = '0.88'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
            onMouseLeave={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'none'; }}
          >
            <MdHome size={18} /> Go Home
          </button>
        </div>

        <p style={{ color: 'rgba(255,255,255,0.25)', fontSize: 12, marginTop: 28 }}>
          TechProOne · If you think this is a mistake, contact support.
        </p>
      </div>
    </div>
  );
}
